module.exports = __webpack_public_path__ + "img/parepare-arrow.723fc7b1.svg";